import { TwoColumnLayout } from './TwoColumn.styled'

const TwoColumn = ({ children }) => {
  return <TwoColumnLayout>{children}</TwoColumnLayout>
}

export default TwoColumn
